"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPricesAndContracts = function IconPricesAndContracts(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M21 16h2V7h15l.176.005A3 3 0 0 1 41 10v25h-9v2h11V10l-.005-.217A5 5 0 0 0 38 5H21zm13-1v-1h-8v1zm2-4v1H26v-1zm-6.084 16.582L15.348 13.054l-12.07 1.869-1.977 12.222 3.357 3.366c.14 4.552 2.15 8.359 4.592 8.359l.172-.006c.788-.053 1.365-.483 2.005-1.385l.073-.107 4.322 4.334a4.39 4.39 0 0 0 6.216 0l7.88-7.91a4.39 4.39 0 0 0-.002-6.214m-19.134 9.07-5.049-5.063c.373 3.552 1.95 6.281 3.517 6.281.493 0 .857-.251 1.372-.984zm-5.079-7.926 11.535 11.568c.404.404.937.65 1.503.694l.189.008a2.4 2.4 0 0 0 1.692-.702l7.882-7.912a2.39 2.39 0 0 0 0-3.384L14.652 15.186l-9.631 1.491-1.582 9.778 1.356 1.36c.375-2.796 1.443-5.154 2.79-6.215a2.16 2.16 0 1 1 .337 1.053c-1.085 1.084-1.994 3.386-2.219 6.073m3.045-6.64a1.162 1.162 0 0 0 1.882.15c-.381-.244-.854-.336-1.38-.246q-.251 0-.502.096m2.125-.858a1.16 1.16 0 0 0-2.207-.173q.245-.057.494-.057a2.8 2.8 0 0 1 1.713.23",
    clipRule: "evenodd"
  })));
};

export { IconPricesAndContracts, IconPricesAndContracts as default };
